<!--  -->
<template>
  <div class='layout'>
    <Aside></Aside>
    <bar></bar>
    <div class="detail-container">
      <div v-if="!detail.link" class="top-imgs">
        <Swiper ref="detailImg" :options="swiperOption">
          <SwiperSlide v-for="(item,i) in detail.num" :key="i"><img v-viewer="{title:false,navbar:false}" ref="viewer" :src="`${$url}/${detail.id}/${i + 1}.JPG`" alt=""></SwiperSlide>
          

        </Swiper>
        
      </div>
      <div v-else class="top-imgs">
        <iframe :src="detail.link" frameborder="0"></iframe>
        <div class="showScreen" @click="fullscreen"><img src="@/assets/images/bigger.png" alt=""></div>
      </div>
      <div class="bot-info">
        <p class="title">{{detail.name}}</p>
        <p class="content"><span>尺寸：{{detail.size}}</span> <span>质地：{{detail.nature}}</span> <span>类别：{{detail.type}}</span><span>级别：{{detail.grade}}</span></p>
      </div>
      <div class="page-icon prev" @click="prev"><img src="../../assets/images/left.png" alt=""></div>
      <div class="page-icon next" @click="next"><img src="../../assets/images/right.png" alt=""></div>
    </div>
    <div class="fullcontainer" v-show="isShow">
      <iframe :src="detail.link" frameborder="0"></iframe>
      <span class="hideScreen" @click="fullscreen"><img src="@/assets/images/smaller.png" alt=""></span>
    </div>
  </div>
  
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import aside from '@/components/layout/aside.vue'
  import bar from '@/components/layout/bar.vue'
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      'Aside': aside,
      bar,
      Swiper,
      SwiperSlide
    },
    data() {
      //这里存放数据

      return {
          isShow:false,
          detail:{},
          swiperOption: {
          autoplay: false,
          navigation: {
            nextEl: '.next', //前进按钮的css选择器或HTML元素。
            prevEl: '.prev',
          },
          
        }
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      fullscreen() {
        console.log("1")
        this.isShow = !this.isShow;
        
      },
      prev() {
        this.$refs.detailImg.$swiper.slidePrev();
      },
      next() {
        this.$refs.detailImg.$swiper.slideNext();
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
       
       this.detail =JSON.parse(this.$route.query.data);
       
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .fullcontainer {
    position:absolute;
    top:0;
    z-index:222222;
    width:100%;
    height:100%;
    iframe {
      width:100%;
      height:100%;
    }
    .hideScreen {
      position:absolute;
      right:10px;
      bottom:10px;
      width:30px;
    }
  }
  .detail-container {
    position: relative;
    width: 63.54vw;
    margin: 7.2vw auto 0;

    .top-imgs {
      position:relative;
      width: 52vw;
      width:46vw;
      height:31vw;
      // height: 34.58vw;
      margin: 0 auto;
      // border: 2px solid #e60012;
      .showScreen {
          position:absolute;
          z-index:222;
          bottom:10px;
          right:10px;
          width:36px;
          
      }
      iframe {
        width:100%;
        height:100%;
      }
    }

    .bot-info {
      width: 62.5vw;
      margin: 1.56vw auto 0;
      background: #e60012;
      padding: 1vw;
      box-sizing: border-box;

      p {
        color: #fff;
        font-size: 1vw;
        text-align: start;
      }

      .title {
        margin-bottom: 1vw;
        text-indent: 2em;
        font-weight: bold;
      }

      .content {
        text-indent: 2em;
        span {
          margin-right:2em;
        }
      }
    }

    .page-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 1.5625vw;
      height: 2.76vw;

      &.next {
        right: 0;
      }

      &.prev {
        left: 0;
      }
    }
  }

  @media screen and (max-width:600px) {
    .fullcontainer {
      
      .hideScreen {
        position:absolute;
        right:10px;
        bottom:10px;
        width:20px;
      }
    }
    .detail-container {
      position: relative;
      width: 100%;
      margin: 21vw auto 0;

      .top-imgs {
        width: 100%;
        height: 67vw;
        margin: 0 auto;
        // border: 1px solid #e60012;
        .showScreen {
          
          width:8vw;
          
        }
      }

      .bot-info {
        width: 100%;
        margin: 1.56vw auto 0;
        background: none;
        padding: 5.3vw;
        box-sizing: border-box;

        p {
          color: #000;
          font-size: 4vw;
          text-align: start;
        }

        .title {
          margin-bottom: 1vw;
          
          font-weight: bold;
          color:#e60012;
        }

        .content {
          text-indent: 2em;
          span {
            display:block;
          }
        }
      }

      .page-icon {
        position: absolute;
        z-index:22;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 4vw;
        height: 6.93vw;
        top:30vw;
        bottom:auto;

        &.next {
          right: 5.3vw;
        }

        &.prev {
          left: 5.3vw;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/Detail/index.vue